class SortableDataTableControl {
	constructor(node, dataSource, dataConfiguration) {
		this._sortIndex = '';
		this._sortAsc = true;
		this._dataSource = dataSource;
		this._dataConfiguration = dataConfiguration;
		this._node = node;
		this._rows = this.buildRows(dataConfiguration,dataSource.data.dataFields);
		this._titleRow = this.buildTitleRow(dataSource.data.dataFields);
		this.sortRows(dataSource.data.dataFields[0], true);
		this._node.addEventListener('click', this.handleHeadClicked.bind(this));
		this.render();
	}

	buildTitleRow(dataFields) {
		var titleRow = document.createElement('tr');
		for (var i = 0; i < dataFields.length; i++) {
			var thNode = document.createElement('th');
			thNode.innerText = dataFields[i].name;
			thNode.setAttribute('source-data-col', dataFields[i].index);
			titleRow.appendChild(thNode);
		}
		return titleRow;
	}

	buildRows(dataConfiguration,dataFields) {
		var {styleTR} = dataConfiguration;
		let rowNodes = []; 
		var rows = this._dataSource.data.rows;

		for (var i = 0; i < rows.length; i++) {
			let currentRow = rows[i];
			let trNode = document.createElement('tr');
			if(styleTR){
				styleTR(trNode,currentRow);
			}
			trNode.setAttribute('source-data-index', i);
			for (var j = 0; j < dataFields.length; j++) {
				let {index} = dataFields[j];
				let tdNode = document.createElement('td');
				tdNode.innerText = currentRow[index];
				trNode.setAttribute(`data-${index}`, currentRow[index]);
				trNode.appendChild(tdNode);
			}
			
			trNode.addEventListener('click', () => {
				this.clearRowHighlights();
				this.applyRowHighlight(trNode);
			});
			rowNodes.push(trNode);
		}

		return rowNodes;
	}

	handleHeadClicked(e) {
		var sortIndex = e.target.getAttribute('source-data-col');
		if (sortIndex) {
			this.sortRows(sortIndex);
			this.applySortIndicator(e.target);
		}
	}

	applySortIndicator(node) {
		var headers = document.querySelectorAll('th');
		for (var i = 0; i < headers.length; i++) {
			var header = headers[i];
			header.classList.remove('sort', 'sort--desc', 'sort--asc');
		}
		node.classList.add('sort');
		if (this._sortAsc) {
			node.classList.add('sort--asc');
		} else {
			node.classList.add('sort--desc');
		}
	}

	applyRowHighlight(rowNode) {
		rowNode.classList.add('highlighted');
	}
	
	clearRowHighlights() {
		for (var i = 0; i < this._rows.length; i++) {
			this._rows[i].classList.remove('highlighted');
		}

		//remove highlightedSection from all sections
		var sections = document.querySelectorAll('.highlightedSection');
		for (var i = 0; i < sections.length; i++) {
			sections[i].classList.remove('highlightedSection');
		}
	}

	sortRows(sortIndex) {
		this.render();
		if (this._sortIndex === sortIndex) {
			this._sortAsc = !this._sortAsc;
		}
		this._sortIndex = sortIndex;
		var dataRows = this._dataSource.data.rows;
		this._rows.sort((rowA, rowB) => {
			var dataIndexA = rowA.getAttribute('source-data-index');
			var dataIndexB = rowB.getAttribute('source-data-index');
			var dataA = this._makeSortable(dataRows[dataIndexA][sortIndex]);
			var dataB = this._makeSortable(dataRows[dataIndexB][sortIndex]);

			if (dataA < dataB) {
				return this._sortAsc ? -1 : 1;
			}
			if (dataA > dataB) {
				return this._sortAsc ? 1 : -1;
			}
			return 0;
		});
		this.render();
	}

	_makeSortable(sortData) {
		if (!sortData) {
			return 0;
		}
		if (sortData.toLowerCase) {
			return sortData.toLowerCase();
		}

		return sortData;
	}

	render() {
		this._node.innerHTML = '';
		this._node.appendChild(this._titleRow);
		for (var i = 0; i < this._rows.length; i++) {
			var row = this._rows[i];
			this._node.appendChild(row);
		}
	}
}

export default SortableDataTableControl;